import { useContext } from 'react';
import { InitialStateContext } from '../context/InitialState';

export const useMucd = () => {
  const { mucd } = useContext(InitialStateContext);
  return mucd;
};
